import {
	ifAuthenticated,
	ifNotAuthenticated,
	ifAuthenticatedOnline,
	AppTabs,
	Edit,
	Create,
	Index
} from '@/router/index'

import Profile from '@/components/user/Profile'
import User from '@/components/user/User'

export const users = [
	{
		path: '/users',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/users/',
					text: 'Utenti'
				}
			]
		},
		children: [
			{
				path: '/users/',
				beforeEnter: ifAuthenticated,
				component: Index,
				props: {
					modelDef: 'users',
					'action-icon': 'group',
					title: 'Utenti'
				}
			}
		]
	},
	{
		path: '/users/create',
		name: 'users-create',
		beforeEnter: ifAuthenticated,
		component: Create,
		props: route => ({
			modelDef: 'users',
			defaultInput: route.params.defaultInput				? route.params.defaultInput				: null,
			redirect: route.params.redirect
		})
	},
	{
		path: '/users/:id/edit',
		name: 'users-edit',
		beforeEnter: ifAuthenticated,
		component: Edit,
		props: route => ({
			modelDef: 'users',
			id: parseInt(route.params.id),
			redirect: { modelDef: 'users', id: parseInt(route.params.id) }
		})
	},
	{
		path: '/users/:id',
		name: 'users',
		beforeEnter: ifAuthenticated,
		component: User,
		props: route => ({
			id: parseInt(route.params.id)
		})
	},
	{
		path: '/profile/',
		name: 'profile',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/profile/',
					text: 'Profilo'
				}
			]
		},
		children: [
			{
				path: '/profile/',
				beforeEnter: ifAuthenticatedOnline,
				component: Profile,
				props: {
					modelDef: 'profile',
					'action-icon': 'account_circle',
					title: 'Profilo'
				}
			}
		]
	}
]
